<template>
  <article id="policy-details-payment" data-test-policy-payment-information>
    <h2 data-test-policy-payment-information-label>
      {{ modelValue.PaymentTitle }}
    </h2>

    <field
      :model-value="modelValue.PaymentMethod"
      name="policy-details-payment-method"
      data-test-policy-payment-information-payment-method
    />

    <field
      :model-value="modelValue.PaymentRate"
      name="policy-details-payment-interval"
      data-test-policy-payment-information-payment-interval
    />

    <payment-information
      v-if="showMissingPayments"
      :model-value="modelValue.MissingPayments"
      data-test-policy-payment-information-missing-payment
    />

    <payment-information
      v-if="showPreviousPayments"
      :model-value="modelValue.PreviousPayments"
      data-test-policy-payment-information-previous-payment
    />

    <payment-information
      v-if="showNextPayment"
      :model-value="modelValue.NextPayment"
      data-test-policy-payment-information-next-payment
    />

    <field
      :model-value="modelValue.PaymentTaxText"
      name="policy-details-payment-tax"
      data-test-policy-payment-information-payment-tax
    />
  </article>
</template>

<script>
import Field from './Field.vue';
import PaymentInformation from './PaymentInformation.vue';
import './PaymentMethodForm.vue'; // TODO: is this needed?

export default {
  name: 'Payment',
  components: {
    Field,
    PaymentInformation
  },
  props: {
    modelValue: {
      type: Object,
      default() {
        return null;
      }
    }
  },
  computed: {
    showMissingPayments() {
      return this.arePaymentsValid(this.modelValue?.MissingPayments?.Payments);
    },
    showPreviousPayments() {
      return this.arePaymentsValid(this.modelValue?.PreviousPayments?.Payments);
    },
    showNextPayment() {
      return this.arePaymentsValid(this.modelValue?.NextPayment?.Payments);
    }
  },
  methods: {
    arePaymentsValid(payments) {
      return Array.isArray(payments) && payments.length > 0;
    }
  }
};
</script>
